import PropTypes from 'prop-types';

/**
 * Action row Table renders from its `actions` slot. Its label names what the actions run on, e.g.
 * "Aktionen für alle 161 Firmen", so the buttons themselves stay count-free. Actions apply to the
 * selection, or to every row matching the table filters when nothing is selected.
 */
const ActionScopeBar = ({ label, children }) => (
	<div className="mb-3 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-primary-200 bg-primary-100 px-3 py-2.5">
		<span className="text-sm font-medium text-text">{label}</span>
		<div className="flex flex-wrap items-center justify-end gap-2">{children}</div>
	</div>
);

ActionScopeBar.propTypes = {
	/** e.g. the result of describeActionScope */
	label: PropTypes.string.isRequired,
	children: PropTypes.node,
};

export default ActionScopeBar;
